/** The toast region: bottom right, at most 360px wide (P13). Mount it once; `lib/toast.ts` fills it.
 *
 * A success is `role="status"` and an error `role="alert"`, so a screen reader hears each once.
 * Motion is in `Toast.module.css` (enter 200ms, exit 140ms; opacity and transform only).
 */

import { X } from "@phosphor-icons/react";

import { dismissToast, useToasts } from "../../lib/toast";
import styles from "./Toast.module.css";

export function ToastRegion() {
  const toasts = useToasts();
  if (toasts.length === 0) return null;
  return (
    <div className={styles.region} data-testid="toast-region">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.kind]} ${toast.leaving ? styles.leaving : ""}`}
          role={toast.kind === "error" ? "alert" : "status"}
          data-testid={`toast-${toast.kind}`}
        >
          <span className={styles.message}>{toast.message}</span>
          <button
            type="button"
            className={styles.close}
            aria-label="Dismiss"
            onClick={() => dismissToast(toast.id)}
          >
            <X size={14} weight="bold" aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>
  );
}
